(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('procedure-diagnosis', {
            parent: 'entity',
            url: '/procedure-diagnosis?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ProcedureDiagnoses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnoses.html',
                    controller: 'ProcedureDiagnosisController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('procedure-diagnosis-detail', {
            parent: 'entity',
            url: '/procedure-diagnosis/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ProcedureDiagnosis'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-detail.html',
                    controller: 'ProcedureDiagnosisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ProcedureDiagnosis', function($stateParams, ProcedureDiagnosis) {
                    return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'procedure-diagnosis',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('procedure-diagnosis-detail.edit', {
            parent: 'procedure-diagnosis-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html',
                    controller: 'ProcedureDiagnosisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProcedureDiagnosis', function(ProcedureDiagnosis) {
                            return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('procedure-diagnosis.new', {
            parent: 'procedure-diagnosis',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html',
                    controller: 'ProcedureDiagnosisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rank: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('procedure-diagnosis', null, { reload: 'procedure-diagnosis' });
                }, function() {
                    $state.go('procedure-diagnosis');
                });
            }]
        })
        .state('procedure-diagnosis.edit', {
            parent: 'procedure-diagnosis',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html',
                    controller: 'ProcedureDiagnosisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProcedureDiagnosis', function(ProcedureDiagnosis) {
                            return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('procedure-diagnosis', null, { reload: 'procedure-diagnosis' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('procedure-diagnosis.delete', {
            parent: 'procedure-diagnosis',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-delete-dialog.html',
                    controller: 'ProcedureDiagnosisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProcedureDiagnosis', function(ProcedureDiagnosis) {
                            return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('procedure-diagnosis', null, { reload: 'procedure-diagnosis' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
